const VALID_THEMES = new Set(['business', 'relationships', 'governance', 'self_discipline', 'strategy', 'ethics']);

export default function deriveChanakyaReading(cellNumber, data) {
  if (!Number.isInteger(cellNumber) || cellNumber < 1 || cellNumber > 36) {
    throw new RangeError(`cellNumber must be an integer in [1, 36], got ${cellNumber}`);
  }
  const aphorism = data.aphorisms[cellNumber - 1];
  if (!aphorism || aphorism.cell !== cellNumber) {
    throw new Error(`aphorisms[${cellNumber - 1}].cell must equal ${cellNumber}`);
  }
  if (!VALID_THEMES.has(aphorism.theme)) {
    throw new Error(`aphorism.theme invalid: ${aphorism.theme}`);
  }
  ['shloka_sa', 'translation_ta', 'interpretation_ta', 'interpretation_en'].forEach(k => {
    if (typeof aphorism[k] !== 'string' || aphorism[k].length === 0) {
      throw new Error(`aphorism.${k} missing`);
    }
  });
  return aphorism;
}
